"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    once: true,
    threshold: 0.2
  });
  return <section id="contact-cta" ref={ref} className="relative py-24 bg-muted" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(1rem)",
    transition: "opacity 150ms ease-out, transform 150ms ease-out"
  }}>
      <div className="container mx-auto px-6 max-w-4xl text-center">
        <h2 className="text-4xl md:text-5xl font-display font-extralight text-foreground mb-4">
          Let's Start a Conversation
        </h2>
        <p className="text-base md:text-lg text-muted-foreground mb-8">
          Ready to elevate your brand? Reach out to our team today.
        </p>
        <Link to="/ContactPage">
          <Button size="lg" className="btn-primary shadow-[inset_0_1px_2px_rgba(0,0,0,0.1)] transition-all duration-[80ms] hover:scale-[1.02]">
            Get in Touch
          </Button>
        </Link>
      </div>
    </section>;
}